import React, { useState } from 'react'
import { FormControl, FormControlLabel, FormGroup, Checkbox } from '@material-ui/core'
import { useStyles} from '../BrowserStyle'
import Chip from '@material-ui/core/Chip';
import AttachmentOutlinedIcon from '@material-ui/icons/AttachmentOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ImageDialog from './DialogImage';
import { isBrowser } from 'react-device-detect';
import Divider from '@material-ui/core/Divider';
import { Button, TextField } from '@material-ui/core'

export function CheckboxGroupControl( { respuestas, archivos_respuesta, preg, handleChange } ) {
    const classes = useStyles()
    const selecciona = (rpta) => {
        let selected = false;
        preg.RESPUESTA.forEach(element => {
            if (element === rpta.toString() )
                selected = true;
        });
        return selected;
    }
    
    const [isOpen, setIsOpen] = useState(false);
    const [filtro, setFiltro] = useState({ pregunta: 0, respuesta: 0 });

    const handleOpen = ( objeto ) => {
        setIsOpen(!isOpen);
        setFiltro(objeto);
    };

    return (
        <>
		<table>
		
            <FormControl component="fieldset">
			<tr>
                {/* <FormGroup column={!isBrowser} row={isBrowser}> */}
                <FormGroup column={ true }>
                    {
                        respuestas.filter( rpta => rpta.ID_PREGUNTA === preg.ID )
                        .map( rpta => (
                            <>
						
                                <div className={ isBrowser && classes.align_items_middle }>
                                   <tbody>
								   <tr>
								   <FormControlLabel className={ classes.radioStyle }
                                        control={
                                            <Checkbox 
                                                options={ rpta }
                                                id={ preg.ID + '_' + rpta.ID  }
                                                name={ preg.ID + '_' + rpta.ID }
                                                checked={ selecciona(rpta.ID) }
                                              //  check={ selecciona(rpta.checked) }
                                                onChange={ ( e ) => handleChange( e, preg.ID ) }
                                                color="primary"
                                            />
                                        }
                                        label={ rpta.DESCRIPCION}
										
                                    />
								</tr>
								<tr>
									
										
										<div className="ed-grid s-grid-1">
                                        { rpta.NOTA_RESPUESTA} 
                                 
										
                                    </div>
									</tr>
									</tbody>
                                    {
                                        rpta.IND_IMAGEN != '0'
                                        &&
                                        <Chip
                                            icon={<InfoOutlinedIcon />}
                                            label="Imagen"
                                            clickable
                                            color="primary"
                                            variant="outlined"
                                            size="small"
                                            onClick={ () => handleOpen( { pregunta: preg.ID, respuesta: rpta.ID } ) }
                                            // onDelete={handleDelete}
                                        />
                                    }
                                </div>
								
								
								
								
                                {
                                    (!isBrowser)
                                    &&
                                    <Divider variant="middle" style={{ marginTop: '7px', marginBottom: '12px' }} />
                                }
                            </>
                        ) )
						
						
                    }
					
					
                </FormGroup>
				</tr>
            </FormControl>
			</table>
            <ImageDialog
            isDialogOpened={isOpen}
            filtro={filtro}
            listaArchivos={archivos_respuesta}
            handleCloseDialog={() => setIsOpen(false)}
            tipo="respuesta"
            />
        </>
    )
}
